import { TPrototypeDto } from '@app-velocity/av-api-v2';

import { epochToLocalDateTimeIso } from '@app-velocity/common';

import {
  PrototypeQueryOptions,
  UrlSimulationPrototypeQueryOptions,
} from '../types';

export const normalizeOwnerFilter = (
  filter?: 'own' | 'all' | string | null
) => {
  if (!filter || filter === 'own')
    return {
      filter: 'own',
    };
  if (filter === 'all')
    return {
      filter: undefined,
    };

  return {
    userId: filter,
  };
};

export const buildPrototypeQueryParams = (
  sourceId: string | null | undefined,
  options?: PrototypeQueryOptions & { page?: number }
) => ({
  prototypeStatuses: ['PUBLISHED'] as Exclude<
    TPrototypeDto['status'],
    undefined
  >[],
  sourceId: sourceId || '',
  ...normalizeOwnerFilter(options?.owner),
  fileName: options?.fileName || undefined,
  pageName: options?.pageName || undefined,
  flowName: options?.flowName || undefined,
  category: options?.category || undefined,
  dateFrom: epochToLocalDateTimeIso(options?.from),
  dateTo: epochToLocalDateTimeIso(options?.to),
  page: options?.page,
  size: options?.size,
});

export const buildUrlSimulationPrototypeQueryParams = (
  options?: UrlSimulationPrototypeQueryOptions & { page?: number }
) => ({
  ...normalizeOwnerFilter(options?.owner),
  url: options?.url || undefined,
  dateFrom: epochToLocalDateTimeIso(options?.from),
  dateTo: epochToLocalDateTimeIso(options?.to),
  page: options?.page,
  size: options?.size,
});
